import React, { useEffect, useState } from 'react'
import { Link, useLocation } from "react-router-dom";

import {
    Sidebar,
    Menu,
    MenuItem,
    SubMenu
} from 'react-pro-sidebar';
import { getUsuarioStorage } from '../helpers/getUsuarioStorage';
import { useGetPantallas } from '../hooks/useGetPantallas';

const menuItemStyles = {

    button: ({ active }) => {

        return {
            borderRadius: '14px',
            margin: '6px 12px',
            height: 48,
            color: active
                ? 'var(--color-secundario-contraste)'
                : 'var(--color-sidebar-texto)',

            backgroundColor: active
                ? 'var(--color-secundario)'
                : 'transparent',

            boxShadow: active
                ? '0 4px 12px rgba(0,0,0,.20)'
                : 'none',

            fontWeight: active ? 700 : 500,

            '&:hover': {
                backgroundColor: 'var(--color-sidebar-hover)',
                color: 'var(--color-sidebar-texto)',
            },
        };
    },

    icon: {
        color: 'inherit',
        fontSize: '16px',
    },

    label: {
        fontSize: '14px',
        fontWeight: 500,
    },

    subMenuContent: {
        backgroundColor: 'var(--color-sidebar-oscuro)',
        borderRadius: '12px',
        margin: '0 10px',
    },

};

export const SideMenu = ({
    collapsed,
    toggled,
    setToggled
}) => {


    let [usuario] = useState(getUsuarioStorage())
    const pantallas = useGetPantallas();
    const location = useLocation();
    const [openMenu, setOpenMenu] = useState(null);

    // const toggleAdmin = () => {
    //     setOpenMenu(openMenu === "admin" ? null : "admin");
    // };

    // const toggleInformes = () => {
    //     setOpenMenu(openMenu === "informes" ? null : "informes");
    // };

    useEffect(() => {

        if (
            location.pathname === "/tiposAtencion" ||
            location.pathname === "/modulos-creacion" ||
            location.pathname === "/ubicaciones" ||
            location.pathname === "/usuarios" ||
            location.pathname === "/videos-admin" ||
            location.pathname === "/mi-empresa"
        ) {
            setOpenMenu("admin");

        }
        else if (
            location.pathname === "/informes" ||
            location.pathname === "/nuevo-dashboard" ||
            location.pathname === "/lista-Pacientes"
        ) {
            setOpenMenu("informes");

        }

    }, [location.pathname]);


    const handleNavigate = () => {

        if (window.innerWidth < 768) {
            setToggled(false);
        }

    };




    return (

        <Sidebar
            collapsed={collapsed}
            toggled={toggled}
            onBackdropClick={() => setToggled(false)}
            breakPoint="md"
            backgroundColor="var(--color-sidebar)"
            rootStyles={{
                border: 'none',
                minHeight: '100vh',
                color: 'var(--color-sidebar-texto)',
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <div className="sidebar-header" style={{ padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 12 }}>

                    {usuario.imagenLogo || usuario.imagenIcono ? (
                        <img
                            src={
                                (usuario.imagenLogo || usuario.imagenIcono).startsWith('http')
                                    ? (usuario.imagenLogo || usuario.imagenIcono)
                                    : `${usuario.imagenLogo || usuario.imagenIcono}`
                            }
                            alt="Logo Empresa"
                            style={{
                                maxHeight: 42,
                                maxWidth: collapsed ? 36 : 120,
                                objectFit: 'contain',
                                borderRadius: 8,
                                background: '#ffffff',
                                padding: 4,
                            }}
                            onError={(e) => {
                                e.target.style.display = 'none';
                            }}
                        />
                    ) : (
                        <div className="logo-circle">
                            {usuario.nombreEntidad ? usuario.nombreEntidad.charAt(0).toUpperCase() : 'T'}
                        </div>
                    )}

                    {
                        !collapsed &&
                        (
                            <div style={{ overflow: 'hidden', minWidth: 0, flex: 1 }}>
                                <div
                                    style={{
                                        color: 'var(--color-sidebar-texto)',
                                        fontWeight: 800,
                                        fontSize: 15,
                                        lineHeight: '1.2',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden'
                                    }}
                                >
                                    {usuario.nombreEntidad || 'TicketsApp'}
                                </div>

                                <small
                                    style={{
                                        color: 'var(--color-sidebar-texto)',
                                        opacity: 0.8,
                                        fontSize: 12,
                                        display: 'block',
                                        marginTop: 2
                                    }}
                                >
                                    {usuario.modulo}
                                </small>
                            </div>
                        )
                    }

                </div>

                <div style={{ flex: 1 }}>
                    <Menu menuItemStyles={menuItemStyles}>

                        {
                            pantallas.includes("escritorios") && usuario.uidModulo !== 'none'
                            && (
                                <MenuItem
                                    active={location.pathname === "/modulo"}
                                    icon={<i className="fa-solid fa-desktop"></i>}
                                    component={<Link to="/modulo" />}
                                    onClick={handleNavigate}
                                >
                                    Módulo
                                </MenuItem>

                            )
                        }

                        {
                            pantallas.includes("consultorios") && usuario.uidModulo !== 'none'
                            && (
                                <MenuItem
                                    active={location.pathname === "/consultorio"}
                                    icon={<i className="fa-solid fa-user-doctor"></i>}
                                    component={<Link to="/consultorio" />}
                                    onClick={handleNavigate}
                                >
                                    Consultorio
                                </MenuItem>

                            )
                        }

                        {
                            (pantallas.includes("tiposatencion") ||
                                pantallas.includes("creacionescritorios") ||
                                pantallas.includes("creacionubicaciones") ||
                                pantallas.includes("usuarios") ||
                                pantallas.includes("videoslistas"))
                            && (
                                <SubMenu
                                    key={`admin-${openMenu === "admin"}`}
                                    open={openMenu === "admin"}
                                    onOpenChange={(open) => setOpenMenu(open ? "admin" : null)}
                                    label="Administración"
                                    icon={<i className="fa-solid fa-gear"></i>}
                                >
                                    {pantallas.includes("tiposatencion")
                                        && (
                                            <>
                                                <MenuItem
                                                    active={location.pathname === "/tiposAtencion"}
                                                    component={<Link to="/tiposAtencion" />}
                                                    onClick={handleNavigate}
                                                >
                                                    Tipos Atención
                                                </MenuItem>
                                                <MenuItem
                                                    active={location.pathname === "/modulos-tiposAtencion"}
                                                    component={<Link to="/modulos-tiposAtencion" />}
                                                    onClick={handleNavigate}
                                                >
                                                    Módulos - Tipos Atención
                                                </MenuItem>
                                            </>
                                        )
                                    }
                                    {pantallas.includes("creacionubicaciones")
                                        && (

                                            <MenuItem
                                                active={location.pathname === "/ubicaciones"}
                                                component={<Link to="/ubicaciones" />}
                                                onClick={handleNavigate}
                                            >
                                                Ubicaciones/Sedes
                                            </MenuItem>
                                        )
                                    }
                                    {pantallas.includes("creacionescritorios")
                                        && (

                                            <MenuItem
                                                active={location.pathname === "/modulos-creacion"}
                                                component={<Link to="/modulos-creacion" />}
                                                onClick={handleNavigate}
                                            >
                                                Módulos
                                            </MenuItem>
                                        )
                                    }

                                    {pantallas.includes("usuarios")
                                        && (
                                            <MenuItem
                                                active={location.pathname === "/usuarios"}
                                                component={<Link to="/usuarios" />}
                                                onClick={handleNavigate}
                                            >
                                                Usuarios
                                            </MenuItem>

                                        )
                                    }
                                    {pantallas.includes("videoslistas")
                                        && (

                                            <MenuItem
                                                active={location.pathname === "/videos-admin"}
                                                component={< Link to="/videos-admin" />}
                                                onClick={handleNavigate}
                                            >
                                                Lista de Videos
                                            </MenuItem>
                                        )
                                    }

                                    {(pantallas.includes("tiposatencion") || pantallas.includes("miempresa") || pantallas.includes("usuarios"))
                                        && (
                                            <MenuItem
                                                active={location.pathname === "/mi-empresa"}
                                                component={<Link to="/mi-empresa" />}
                                                onClick={handleNavigate}
                                            >
                                                🏢 Mi Empresa
                                            </MenuItem>
                                        )
                                    }


                                </SubMenu>
                            )
                        }


                        {
                            (pantallas.includes("informes") ||
                                pantallas.includes("listapacientes"))
                            && (
                                <SubMenu
                                    key={`informes-${openMenu === "informes"}`}
                                    open={openMenu === "informes"}
                                    onOpenChange={(open) => setOpenMenu(open ? "informes" : null)}
                                    label="Informes"
                                    icon={<i className="fa-solid fa-chart-column"></i>}
                                >
                                    {pantallas.includes("informes")
                                        && (
                                            <MenuItem
                                                active={location.pathname === "/informes"}
                                                component={<Link to="/informes" />}
                                                onClick={handleNavigate}
                                            >
                                                Dashboard
                                            </MenuItem>

                                        )
                                    }

                                    {pantallas.includes("informes")
                                        && (
                                            <MenuItem
                                                active={location.pathname === "/nuevo-dashboard"}
                                                component={<Link to="/nuevo-dashboard" />}
                                                onClick={handleNavigate}
                                            >
                                                Dashboard Consultorios
                                            </MenuItem>

                                        )
                                    }


                                    {pantallas.includes("listapacientes")
                                        && (
                                            <MenuItem
                                                active={location.pathname === "/lista-Pacientes"}
                                                component={<Link to="/lista-Pacientes" />}
                                                onClick={handleNavigate}
                                            >
                                                Lista Pacientes
                                            </MenuItem>

                                        )
                                    }

                                </SubMenu>

                            )
                        }


                    </Menu>

                </div>
</div>



        </Sidebar>

    )
}